import { Currency } from '@sequencehq/api'
import {
  dateMustNotBeBefore,
  decimal,
  greaterThan,
  lessThanEqualToField,
  maxLength,
  required,
  Validator
} from '@sequencehq/utils/validation'
import { GRANT_PRICE_VALIDATORS } from 'CreditGrants/index'

export type Expiry = 'NEVER' | 'ON_DATE'

// Field names match the request body, so the platform's validation errors land
// on the field they are about.
export type CustomerCreditGrantFormValues = {
  currency: Currency
  amount: string
  isCharged: boolean
  costOfCredit: string
  effectiveDate: string
  expiry: Expiry
  expiryDate: string
  name: string
}

// The sign is checked before the decimals, as in GRANT_PRICE_VALIDATORS.
export const AMOUNT_VALIDATORS: Validator[] = [
  required,
  greaterThan(0, 'Credit amount must be more than zero'),
  decimal('2')
]

// The platform refuses a price above the credit it buys.
export const COST_OF_CREDIT_VALIDATORS: Validator[] = [
  ...GRANT_PRICE_VALIDATORS,
  lessThanEqualToField(
    'amount',
    'Price charged cannot be more than the credit amount'
  )
]

// Both dates are inclusive, so expiring on the effective date is allowed.
export const EXPIRY_DATE_VALIDATORS: Validator[] = [
  required,
  dateMustNotBeBefore(
    'effectiveDate',
    'Expiry date cannot be before the effective date'
  )
]

// The platform's limit on a grant's name.
const NAME_MAX_LENGTH = 256

export const NAME_VALIDATORS: Validator[] = [maxLength(NAME_MAX_LENGTH)]
